<template>
  <div style="width: 100%">
    <div id="top_border" class="top_border_rs">
      <v-row class="top_border_inside">
        <v-col md="3" sm="12" cols="12" class="top_logo d-flex">
          <a :href="vueAppRoot">
            <img src="@/assets/images/mainLogo.png" alt="LiveLaps" height="40" border="0" />
          </a>
          <div class="topMiddleMessage disp960">
            <div class="bigMessage">
              {{ $t('common.header.top-links.promoter-administration', 1) }} - {{ $escapeHtml.decode(promoterName) }}
            </div>
          </div>
        </v-col>
        <v-col md="6" sm="12" cols="12" class="topMiddleMessage">
          <div class="bigMessage">
            {{ $t('common.header.top-links.promoter-administration', 1) }} - {{ $escapeHtml.decode(promoterName) }}
          </div>
        </v-col>
        <v-col md="3" sm="12" cols="12" class="top_links">
          <div class="toplink_item">
            <a href="/admin/logout" :title="$t('common.header.top-links.logout', 1)">
              <i class="far fa-sign-out llnav"></i>
              &nbsp; <span class="dBig">{{ $t('common.header.top-links.logout', 1) }}</span>
            </a>
          </div>
          <TopLangs></TopLangs>
          <ThemeOptions></ThemeOptions>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import TopLangs from "@/components/language/TopLangs.vue";
import ThemeOptions from "@/components/ThemeOptions.vue";
import { mapState } from "vuex";
import { escapeHtml } from "@/helpers/escapeHtml.js";

export default {
  mixins: [apiCalls,escapeHtml],
  data() {
    return {
      promoterName: "",
      headerBGColor: this.$vuetify.theme.themes.primary//"#FFF"
    };
  },
  components: {
    TopLangs,
    ThemeOptions
  },
  computed: {
    ...mapState(["host", "session"]),
    vueAppRoot() {
      return process.env.VUE_APP_ROOT;
    }
  },
  methods: {
    //...mapMutations(['getLang']),
    async getPromoterName() {
      let response = await this.getApi("/api/v1/promoter/name");
      this.promoterName = response;
    }
  },
  created: function() {
    this.headerBGColor = process.env.VUE_APP_HEADER_COLOR;
    this.getPromoterName();
  },
  mounted() {
    this.$emit('changeBand', {index: 'bandHeaderMounted',value: true});
  }
};
</script>

<style>
.top_border_rs {background-color: var(--v-primary-base) !important;}
#top_border {width: 100%; margin: 0px; padding: 0px; border-bottom: 2px solid var(--v-accent-base); max-height: 50px;}
#top_border div { max-height: 50px;}
.top_border_inside {
  width: 80%;
  max-width: 1200px;
  text-align: left;
  padding-top: 4px;
  margin: 0 auto;
  color: var(--v-lighten-base);
  font-size: 24px;
}
.top_logo {float: left; padding: 0; max-width: 200px; margin-top: -1px;}
.top_links {
  color: var(--v-lighten-base);;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 14px;
  text-align: center;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  flex: 0 0 25% !important;
  padding: 0;
  margin-top: -4px;
}
.top_links .toplink_item {float: left; list-style: none; margin-right: 10px;}
.top_links a:visited,
.top_links .languageCode {color: var(--v-lighten-base); font-size: 14px; text-decoration: none;}
.toplink_item a, .llnav {color: var(--v-lighten-base) !important;}
.topMiddleMessage {color: var(--v-lighten-base); white-space: pre; padding: 6px; margin-top: -4px;}
.topMiddleMessage .bigMessage {font-size: 18px; color: var(--v-lighten-base);}
.topMiddleMessage .smallMessage {font-size: 12px; color: var(--v-lighten-base); padding-top: 4px;}
.top_links a:visited { color: var(--v-lighten-base); font-size: 14px; text-decoration: none;}
.disp960 {display: none; margin-left: 1rem;}
@media (max-width: 1232px) {
  .topMiddleMessage {max-width: calc(75% - 200px);}
}
@media (max-width: 500px) {
  .topMiddleMessage .bigMessage {font-size: 14px !important;}
}
@media (max-width: 1024px) {
  .top_border_inside {width: 100%; /*margin: 0;*/}
  .top_logo {padding-bottom: 0px; margin: 0 0 0 auto;}
  .topMiddleMessage {padding-left: 0px;}
  .top_links {margin: 0 auto 0 0;}
}
@media (max-width: 960px) {
  .top_logo {margin: 0 0 0 2rem; max-width: calc(100% - 2rem) !important;}
  .top_links {margin: 0; top: 0; position: absolute; right: .5rem;}
  .disp960 {display: block;}
}
@media (max-width: 750px) {
  .top_border_rs, .top_border_inside {min-height: 80px; height: auto; max-height: 100% !important;}
  .topMiddleMessage, .top_logo {flex: 0 0 100% !important; /*max-width: 100% !important;*/}
  .top_logo {padding: 0; display: flex;}
  .top_logo a {margin: 0 auto 0 0 !important;}
  .topMiddleMessage {text-align: left; margin: 0; padding: 0 0 0 2rem; white-space: normal; max-width: 100%;}
  #top_border {max-height: 80px;}
  #top_border div { max-height: 80px;}  
  .bigMessage {font-size: 19px !important;}
  .disp960 {display: none;}
}
@media (max-width: 400px) {
  .top_logo {margin: 0 0 0 5px;}
  .topMiddleMessage {padding: 0 0 0 5px;}
  .top_links {right: 0; margin: 4px 0 0;}
  .top_links .v-btn--icon.v-size--large { height: auto; width: auto; margin: 0 0 0 -17px;}
  .bigMessage {font-size: 17px !important;}
  .dBig { display: none;}
} 
</style>
